// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import React from "react";

const MENU_WIDTH = 160;
const MENU_HEIGHT = 26;
const EDGE_GAP = 8;

const CustomContextMenu2 = ({ position, label, func }) => {
  // Fixed, not absolute: position holds viewport coordinates, which an
  // absolutely positioned menu would offset by its positioned ancestor.
  const left = Math.max(
    EDGE_GAP,
    Math.min(position.x + 2, window.innerWidth - MENU_WIDTH - EDGE_GAP)
  );
  const top = Math.max(
    EDGE_GAP,
    Math.min(position.y + 2, window.innerHeight - MENU_HEIGHT - EDGE_GAP)
  );

  const menuStyles = {
    position: "fixed",
    top,
    left,
    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
    zIndex: 1000,
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={menuStyles}
      className={`py-1 bg-[#dbdbdb] w-max rounded-md`}
    >
      <div
        className="px-[10px] text-[11px] text-left w-[140px] font-['Roboto'] cursor-pointer hover:bg-[#c4c4c4] text-[#16191d]"
        onClick={func}
      >
        {label}
      </div>
      {/* Add more custom options as needed */}
    </div>
  );
};

export default CustomContextMenu2;
